import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminProvider } from "@/context/AdminContext";
import Layout from "@/components/Layout";
import ElencoAtleti from "@/pages/ElencoAtleti";
import SchedaAtleta from "@/pages/SchedaAtleta";
import Attivita from "@/pages/Attivita";
import Analisi from "@/pages/Analisi";
import Scadenze from "@/pages/Scadenze";
import Gestione from "@/pages/Gestione";
import ResetPassword from "@/pages/ResetPassword";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <AdminProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Attivita />} />
              <Route path="/atleti" element={<ElencoAtleti />} />
              <Route path="/atleti/:id" element={<SchedaAtleta />} />
              <Route path="/analisi" element={<Analisi />} />
              <Route path="/scadenze" element={<Scadenze />} />
              <Route path="/gestione" element={<Gestione />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AdminProvider>
    </div>
  );
}

export default App;
